/* v-tip="html | () => html" — shared floating tooltip rendered once by DashboardShell. */
export function createTipDirective(store) {
  const show = (el, e) => {
    const v = el.__sdTip; if (v == null) return
    const html = typeof v === 'function' ? v() : v; if (!html) return
    store.state.tip = { html, x: e.clientX, y: e.clientY }
  }
  const hide = () => { store.state.tip = null }
  return {
    bind(el, binding) {
      el.__sdTip = binding.value
      el.__sdMove = (e) => show(el, e)
      el.addEventListener('mousemove', el.__sdMove)
      el.addEventListener('mouseleave', hide)
    },
    update(el, binding) { el.__sdTip = binding.value },
    unbind(el) { el.removeEventListener('mousemove', el.__sdMove); el.removeEventListener('mouseleave', hide); hide() },
  }
}

/* Global v-tip: resolves the dashboard store from the nearest component that injected it
   (every dashboard component gets `$sd` through sdMixin), so it works at any depth. */
export const tipDirective = (() => {
  const impl = (vnode) => { let c = vnode.context; while (c && !c.$sd && !(c.store && c.store.state)) c = c.$parent; const store = c ? (c.$sd || c.store) : null; return store ? createTipDirective(store) : null }
  return {
    bind(el, binding, vnode) { const d = impl(vnode); if (d) { el.__sdTipImpl = d; d.bind(el, binding) } },
    update(el, binding) { if (el.__sdTipImpl) el.__sdTipImpl.update(el, binding) },
    unbind(el) { if (el.__sdTipImpl) el.__sdTipImpl.unbind(el) },
  }
})()
